import React, { Component } from 'react';
import { Link } from 'react-router';
import { hasMadeChoice, setConsent, initAnalyticsTracking, trackPageView } from '../../utils/trackingConsent';
import './CookieConsent.scss';

class CookieConsent extends Component {
  constructor(props) {
    super(props);
    this.state = {
      visible: !hasMadeChoice(),
    };
  }

  handleAccept = () => {
    setConsent('accepted');
    initAnalyticsTracking();
    // Record the landing pageview now. GA4 is configured with send_page_view:false and
    // the Pixel PageView fires from trackPageView, so without this a user who accepts and
    // leaves without navigating would generate no pageview at all.
    trackPageView();
    this.setState({ visible: false });
  };

  handleReject = () => {
    setConsent('rejected');
    this.setState({ visible: false });
  };

  render() {
    if (!this.state.visible) return null;

    return (
      <div className="CookieConsent" role="dialog" aria-label="Cookie consent">
        <div className="CookieConsent__content">
          <p className="CookieConsent__text">
            We use cookies and similar technologies for analytics and advertising.
            By clicking &ldquo;Accept All&rdquo; you consent to their use.
            See our{' '}
            <Link to="/privacy-policy" target="_blank" rel="noopener noreferrer">
              Privacy Policy
            </Link>
            {' '}for details.
          </p>
          <div className="CookieConsent__actions">
            <button
              type="button"
              className="CookieConsent__btn CookieConsent__btn--reject"
              onClick={this.handleReject}
            >
              Reject Non-Essential
            </button>
            <button
              type="button"
              className="CookieConsent__btn CookieConsent__btn--accept"
              onClick={this.handleAccept}
            >
              Accept All
            </button>
          </div>
        </div>
      </div>
    );
  }
}

export default CookieConsent;
